import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { accountAuthError, finishAccountLogin, getAuthMethods, passwordLogin, requestWhatsAppLogin, verifyWhatsAppLogin } from "../api/accountAuthApi";
import WhatsAppOtpForm from "./auth/WhatsAppOtpForm";

const CredentialsLoginComponent = () => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const [method, setMethod] = useState("password");
  const [methods, setMethods] = useState(null);
  const [methodError, setMethodError] = useState("");
  const [retryMethods, setRetryMethods] = useState(0);
  useEffect(() => {
    let active = true;
    setMethodError("");
    getAuthMethods().then((result) => {
      if (typeof result?.whatsapp_available !== "boolean") throw new Error("Invalid login methods response.");
      if (active) setMethods(result);
    }).catch((err) => { if (active) setMethodError(accountAuthError(err)); });
    return () => { active = false; };
  }, [retryMethods]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (loading) return;
    setErrorMessage("");
    setLoading(true);

    try {
      const result = await passwordLogin(email, password);
      navigate(await finishAccountLogin(result));
    } catch (err) {
      setErrorMessage(accountAuthError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      {methodError && <p role="alert" className="mb-3 text-sm text-rose-700">Unable to load additional login methods. Password sign-in is available. <button onClick={() => setRetryMethods((value) => value + 1)} className="underline">Retry</button></p>}
      {methods?.whatsapp_available && <div role="group" aria-label="Sign in method" className="mb-4 flex gap-3">
        {[["password", "Password"], ["whatsapp", "WhatsApp OTP"]].map(([value, label]) => <button key={value} type="button"
          aria-pressed={method === value} className={`rounded-lg border px-3 py-2 text-sm ${method === value ? "bg-cyan-800 text-white" : ""}`}
          onClick={() => setMethod(value)}>{label}</button>)}
      </div>}
      {method === "whatsapp" ? <WhatsAppOtpForm request={({ phone }) => requestWhatsAppLogin(phone)} verify={verifyWhatsAppLogin}
        onVerified={async (result) => navigate(await finishAccountLogin(result))} /> : <form onSubmit={handleLogin} className="space-y-4">
        <div>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => { setEmail(e.target.value); setErrorMessage(""); }}
            className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
            placeholder="Email address"
          />
        </div>
        <div>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => { setPassword(e.target.value); setErrorMessage(""); }}
            className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
            placeholder="Password"
          />
        </div>

        {/* inline error banner */}
        {errorMessage && (
          <div role="alert" className="flex items-center gap-2 px-4 py-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-600">
            <svg className="w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            {errorMessage}
          </div>
        )}

        {loading ? (
          <div role="status" aria-label="Signing in" className="flex justify-center py-3">
            <div className="dot-pulse" style={{ backgroundColor: '#4f46e5' }}></div>
          </div>
        ) : (
          <button
            type="submit"
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 px-4 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#1e2532] focus:ring-indigo-500 shadow-lg"
          >
            Sign In
          </button>
        )}
      </form>}
      <Link to="/forgot-password" className="mt-4 block text-sm text-cyan-800 underline">Forgot password?</Link>
    </div>
  );
};

export default CredentialsLoginComponent;
